<div class="animate__animated animate__slideInUp">
    <mat-card>
        <app-lista-cartas-trabajador></app-lista-cartas-trabajador>
    </mat-card>
</div>